<template src="./PasswordResetForm.html"/>
<style lang='scss' scoped src="./PasswordResetForm.scss"/>

<script>

import {SfInput, SfButton, SfNotification} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";
import OrkPasswordJudge from "@/components/Ork/OrkPasswordJudge.vue";

export default {
    name: 'PasswordResetForm',

    components: {
        OrkPasswordJudge,
        OrkRecaptcha,
        SfInput,
        SfNotification,
        SfButton
    },
    props: {
        token: {
            default: null,
            type: String || null
        }
    },
    data() {
        return {
            isSuccess: false,
            isError: false,
            loading: false,
            error: null,
            valid: false,
            passwordValid: false,
            submitted: false,
            newPasswordError: null,
            repeatPasswordError: null,
            newPassword: "",
            newPasswordBlur: true,
            repeatPassword: "",
            repeatPasswordBlur: true,
        }
    },
    methods: {

        validate() {
            this.repeatPasswordBlur = false;
            this.newPasswordBlur = false;
            return this.validRepeatPassword(this.repeatPassword) && this.passwordValid;
        },
        validRepeatPassword(repeatPassword) {
            if (this.newPassword === repeatPassword) {
                this.repeatPasswordError = null;
                return true;
            } else {
                this.repeatPasswordError = this.$i18n.t('repeatPassword.error');
                return false
            }
        },
        executeRecaptcha() {
            this.$refs.recaptcha.execute()
        },
        handleResetPassword(recaptchaData) {

            if (this.validate()) {
                this.loading = true;
                let status = '';
                Api.account.changeResetPassword({
                    newPassword: this.newPassword,
                    resetToken: this.token,
                    recaptchaData
                }).then(() => {
                    status = 'valid'
                }).catch((e) => {
                    status = 'error'
                }).finally(() => {
                    this.loading = false;
                    this.$emit('modal', status)
                })
            }
        },
      onPasswordValid(isPasswordValid) {
        this.passwordValid = isPasswordValid;
      },
    }
};
</script>


